//const anchorme = require("anchorme").default; // like this
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

var trimHtml = require('trim-html');
//import trimHtml from "trimHtml"


var j
var page = 0

if (document.readyState === "complete") {
  console.log("complete")
  j = new domReady()
}
else if (document.readyState === "interactive") {
  console.log("interactive")
  j = new domReady()
}
else {
  // Loading still in progress.
  // To wait for it to complete, add "DOMContentLoaded" or "load" listeners.

  window.addEventListener("DOMContentLoaded", () => {

    console.log("DOMContentLoaded")
    j = new domReady()
  });


}


function domReady() {
  console.log("*")
  var str = "MICHAEL CURSE KURTH"
  var res = str.split(" ")
  var htmlLogo = `<a id="site-title" href="/">` + res[0] + ` <span>` + res[1] + `</span> ` + res[2] + `</a>`

  var logos = document.querySelectorAll(".header-title-text")

  console.log("logos")
  console.log(logos)
  for (let i = 0; i < logos.length; i++) {
    console.log(logos[i])
    logos[i].innerHTML = htmlLogo
    logos[i].classList.add("ready")
  }

  deezerLogo()

  //check if podcast player module is present

  var pod_target = document.querySelector("#podcast_meta")
  console.log("pod_target")
  console.log(pod_target)

  if (pod_target) {
    render_podcast_feed(0, 10)

  }

  let section = document.querySelector("[data-section-id='614b24f5c669f5711e579c78']")

  if (section) {
    let button = section.getElementsByClassName("sqs-block-button-element")

    button[0].addEventListener("click", nextPage)
  }

  let live_date = document.querySelector("#live-date")
  if (live_date) {
    var today = new Date()

    var strDate = "d.m.Y"
      .replace("Y", today.getFullYear())
      .replace("m", today.getMonth() + 1)
      .replace("d", today.getDate())

    live_date.innerHTML = strDate
  }
}

function nextPage() {
  console.log("next page")

  event.preventDefault()
  page += 1

  render_podcast_feed(page, 10)

}

function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>"
  return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2")
}

function render_podcast_feed(offset, perpage) {
  console.log("rendering podcast")
  var rss_url = "https://podcast9059c0.podigee.io/feed/mp3"

  fetch(rss_url)
    .then((response) => response.text())
    .then((str) => new window.DOMParser().parseFromString(str, "text/xml"))
    .then((data) => {
      console.log("podigee data")
      console.log(data)
      const items = data.querySelectorAll("item")
      const channel = data.querySelectorAll("channel")
      const pod_url = channel[0].querySelector("link")

      var list_html = ""

      var rangeStart = offset * perpage
      var rangeEnd = offset * perpage + perpage

      for (var i = rangeStart; i < rangeEnd; ++i) {
        let item = items[i]

        if (item) {
          let hash = "#" + parseInt(items.length - i)

          let item_url = item.querySelector("link").innerHTML
          let audio_url = item.querySelector("enclosure").getAttribute("url")

          var raw_summary = item.getElementsByTagName("itunes:summary")[0].textContent


          const linkify_options = { defaultProtocol: 'https', target: "_blank", };
          var linked_summary = linkifyHtml(raw_summary, linkify_options);


          const paragraphed_summary = lineBreaks(linked_summary)



          var formatted_summary_short = trimHtml(paragraphed_summary, { limit: 340, suffix: "..." }).html;
          var formatted_summary_rest = paragraphed_summary
          var formatted_summary_supershort = trimHtml(paragraphed_summary, { limit: 240, suffix: "..." }).html;

          /*
        var formatted_summary_short = paragraphed_summary
        var formatted_summary_rest = paragraphed_summary
        var formatted_summary_supershort = paragraphed_summary
        

/*
        var formatted_summary_short = lineBreaks(raw_summary.slice(0, 340) + "...")
        var formatted_summary_rest = lineBreaks(raw_summary)
        var formatted_summary_supershort = lineBreaks(raw_summary.slice(0, 240) + "...")
*/

          let meta_html = ``
          let cover_html = ``

          let pod_date = new Date(item.querySelector("pubDate").innerHTML).toLocaleDateString("de-de", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })

          meta_html += `
          <article>
          <p class="sqsrte-large"><strong>${pod_date}</strong></p>

            <h3>
              <a href="${item_url}" target="_blank"><span>${hash}</span><br/>
               ${item.querySelector("title").innerHTML}
              </a>
            </h3>

            <input type="checkbox" class="read-more-state" id="item-${i}" />
            
            <div class="read-more-wrap">
              <div class="summary">${formatted_summary_short}</div>
              <div class="summary-short">${formatted_summary_supershort}</div>

              <div class="summary-full">${formatted_summary_rest}</div>   
              
          </div>

         
          <label for="item-${i}" class="read-more-trigger"></label>

          <div class="pod-player">
          <audio controls="controls">
          <source src="${audio_url}" type="audio/mp3" />
          </audio>
          <div class="pod-sources">
          <span class="label">Auch bei: </span>
            <ul class="pod-icons">
              <li><a class="icon icon--fill" href="https://podcasts.apple.com/de/podcast/meditation-coaching-life-der-podcast-mit-michael-curse/id1191610678?l=en" target="_blank" aria-label="Apple Podcasts"><svg viewBox="23 23 64 64"><use xlink:href="#applepodcast-icon" width="110" height="110"></use></svg></a></li>
              <li><a class="icon icon--fill" href="https://www.deezer.com/de/show/52837" target="_blank" title="deezer"><svg viewBox="23 23 64 64"><use xlink:href="#url-icon" width="110" height="110"></use></svg></a></li>
              <li><a class="icon icon--fill" href="https://open.spotify.com/show/0o5lUuYwDIxnYgGRz4yVAR" target="_blank" title="spotify"><svg viewBox="23 23 64 64"><use xlink:href="#spotify-unauth-icon" width="110" height="110"></use></svg></a></li>
              <li><a class="icon icon--fill" href="https://www.youtube.com/watch?v=962zLkviMgU&list=PLnMOQ6RHt843bSGdJ3T9dANaFQfDJkyW4" target="_blank" title="youtube"><svg viewBox="23 23 64 64"><use xlink:href="#youtube-unauth-icon" width="110" height="110"></use></svg></a></li>
              </ul>
              </div>
              </div>
          </article>
        `

          /*
         <!-- <a href="${item_url}" class="sqs-block-button-element--large sqs-block-button-element" data-initialized="true" target="_blank">Folge jetzt anhören</a><br/> -->
*/


          //    console.log(urlArray)





          if (i == 0) {
            //  console.log(i)

            //   console.log("COVER?")

            let cover_url = ""
            if (item.getElementsByTagName("itunes:image")[0]) {
              cover_url = item.getElementsByTagName("itunes:image")[0].getAttribute("href")
              //  console.log("A")

            } else {
              cover_url = channel[0].querySelector("image").querySelector("url").innerHTML
              // console.log("B")


            }

            cover_html += `<img src="${cover_url}"/>`

            var cover = document.querySelector("#podcast_cover")
            var meta = document.querySelector("#podcast_meta")

            cover.innerHTML = cover_html
            meta.innerHTML = meta_html
          } else {
            list_html += meta_html
          }
        }
      }

      var listbox = document.querySelector("#podcast_list")

      if (listbox) {
        listbox.insertAdjacentHTML("beforeend", list_html)
      }
    })
}

function lineBreaks(input) {
  var formatted_summary = ""
  var regExp = /[^\n]+/g,
    match
  while ((match = regExp.exec(input))) {



    formatted_summary += "<p>" + match[0] + "</p>"
  }

  return formatted_summary
}

function deezerLogo() {
  let logos = document.querySelectorAll("a[href^='https://www.deezer.com']")

  console.log("social logos")
  console.log(logos)

  for (var i = 0; i < logos.length; i++) {
    logos[i].innerHTML =
      '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '                <svg width="39px" height="23px" viewBox="0 0 39 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
      "                <title>Deezer icon</title>\n" +
      '            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
      '                <g id="Styling-Curse-2" transform="translate(-318.000000, -46.000000)" fill="#faf2de">\n' +
      '                <g id="Deezer-icon" transform="translate(318.000000, 46.000000)">\n' +
      '                <polygon id="Fill-1" points="30 5 39 5 39 0 30 0"></polygon>\n' +
      '                <polygon id="Fill-4" points="30 17 39 17 39 12 30 12"></polygon>\n' +
      '                <polygon id="Fill-4" points="30 11 39 11 39 6 30 6"></polygon>\n' +
      '                <polygon id="Fill-6" points="0 23 9 23 9 18 0 18"></polygon>\n' +
      '                <polygon id="Fill-8" points="10 23 19 23 19 18 10 18"></polygon>\n' +
      '                <polygon id="Fill-8" points="10 17 19 17 19 12 10 12"></polygon>\n' +
      '                <polygon id="Fill-8" points="10 11 19 11 19 6 10 6"></polygon>\n' +
      '                <polygon id="Fill-10" points="20 23 29 23 29 18 20 18"></polygon>\n' +
      '                <polygon id="Fill-12" points="30 23 39 23 39 18 30 18"></polygon>\n' +
      '                <polygon id="Fill-14" points="20 17 29 17 29 12 20 12"></polygon>\n' +
      "                </g>\n" +
      "                </g>\n" +
      "                </g>\n" +
      "                </svg>"
  }
}
